import { SeUserModalComponent } from './se-user-modal.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '../../shared/translate/translate.module';

@NgModule({
  declarations: [SeUserModalComponent],
  imports: [
    CommonModule, IonicModule, FormsModule, ReactiveFormsModule, TranslateModule
  ],
  exports: [SeUserModalComponent],
  entryComponents: [SeUserModalComponent]
})
export class SeUserModalModule { }
